// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1 1;
  margin-left: 280px;
  padding: var(--spacing-lg);
  transition: margin-left var(--transition-normal);
  min-height: 100vh;
  position: relative;
}

.dashboard.sidebar-closed .main-content {
  margin-left: 70px;
}

/* Error Banner */
.error-banner {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid var(--accent-red);
  border-radius: var(--radius-md);
  padding: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
  margin-top: var(--spacing-xl);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--accent-red);
}

.error-banner button {
  background: var(--accent-red);
  color: white;
  border: none;
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-sm);
  cursor: pointer;
}

/* Loading State */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  color: var(--text-secondary);
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--border-color);
  border-top-color: var(--accent-blue);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: var(--spacing-md);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  color: var(--text-secondary);
}

.empty-icon {
  margin-bottom: var(--spacing-md);
  opacity: 0.5;
}

.empty-state h2 {
  margin-bottom: var(--spacing-sm);
  color: var(--text-primary);
}

/* Dashboard Grid */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: auto;
  gap: var(--spacing-lg);
  margin-top: var(--spacing-xl);
}

.grid-item {
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  overflow: hidden;
}

.grid-item.ai-agent {
  grid-column: span 12;
  background: linear-gradient(135deg, var(--bg-card) 0%, rgba(99, 102, 241, 0.03) 100%);
  border: 1px solid rgba(99, 102, 241, 0.15);
}

.grid-item.current-conditions {
  grid-column: span 4;
}

.grid-item.metrics {
  grid-column: span 8;
}

.grid-item.weather-map {
  grid-column: span 6;
  min-height: 350px;
}

.grid-item.hourly {
  grid-column: span 6;
}

.grid-item.weekly {
  grid-column: span 7;
}

.grid-item.temperature-trend {
  grid-column: span 5;
}

/* Responsive */
@media (max-width: 1400px) {
  .grid-item.current-conditions,
  .grid-item.metrics {
    grid-column: span 6;
  }
}

@media (max-width: 1200px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
  
  .grid-item {
    grid-column: span 1 !important;
  }
  
  .main-content {
    margin-left: 70px;
  }
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    padding: var(--spacing-md);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,0BAA0B;EAC1B,gDAAgD;EAChD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qFAAqF;EACrF,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;IACd,0BAA0B;EAC5B;AACF","sourcesContent":[".dashboard {\n  display: flex;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  margin-left: 280px;\n  padding: var(--spacing-lg);\n  transition: margin-left var(--transition-normal);\n  min-height: 100vh;\n  position: relative;\n}\n\n.dashboard.sidebar-closed .main-content {\n  margin-left: 70px;\n}\n\n/* Error Banner */\n.error-banner {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid var(--accent-red);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-md);\n  margin-bottom: var(--spacing-lg);\n  margin-top: var(--spacing-xl);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: var(--accent-red);\n}\n\n.error-banner button {\n  background: var(--accent-red);\n  color: white;\n  border: none;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n}\n\n/* Loading State */\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 60vh;\n  color: var(--text-secondary);\n}\n\n.spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--border-color);\n  border-top-color: var(--accent-blue);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: var(--spacing-md);\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Empty State */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 60vh;\n  color: var(--text-secondary);\n}\n\n.empty-icon {\n  margin-bottom: var(--spacing-md);\n  opacity: 0.5;\n}\n\n.empty-state h2 {\n  margin-bottom: var(--spacing-sm);\n  color: var(--text-primary);\n}\n\n/* Dashboard Grid */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  grid-template-rows: auto;\n  gap: var(--spacing-lg);\n  margin-top: var(--spacing-xl);\n}\n\n.grid-item {\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-color);\n  overflow: hidden;\n}\n\n.grid-item.ai-agent {\n  grid-column: span 12;\n  background: linear-gradient(135deg, var(--bg-card) 0%, rgba(99, 102, 241, 0.03) 100%);\n  border: 1px solid rgba(99, 102, 241, 0.15);\n}\n\n.grid-item.current-conditions {\n  grid-column: span 4;\n}\n\n.grid-item.metrics {\n  grid-column: span 8;\n}\n\n.grid-item.weather-map {\n  grid-column: span 6;\n  min-height: 350px;\n}\n\n.grid-item.hourly {\n  grid-column: span 6;\n}\n\n.grid-item.weekly {\n  grid-column: span 7;\n}\n\n.grid-item.temperature-trend {\n  grid-column: span 5;\n}\n\n/* Responsive */\n@media (max-width: 1400px) {\n  .grid-item.current-conditions,\n  .grid-item.metrics {\n    grid-column: span 6;\n  }\n}\n\n@media (max-width: 1200px) {\n  .dashboard-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .grid-item {\n    grid-column: span 1 !important;\n  }\n  \n  .main-content {\n    margin-left: 70px;\n  }\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    margin-left: 0;\n    padding: var(--spacing-md);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
